'use client';

import React from 'react';
import { ToastConfig } from './types';
import { getAlertIcon } from './utils';

interface ToastMessageProps extends Omit<ToastConfig, 'id'> {
  onClose: () => void;
}

const ToastMessage: React.FC<ToastMessageProps> = ({ alertType, content, onClose }) => {
  const icon = getAlertIcon(alertType);
  const showIcon = content.type === 'text' || !content.hideIcon;

  return (
    <div className={`alert alert-${alertType} relative shadow-lg`}>
      {/* Close button */}
      <button onClick={onClose} className="btn btn-ghost btn-sm absolute top-1 right-1">
        ✕
      </button>

      <div className="flex items-start gap-3">
        {/* Icon */}
        {showIcon && <div className="flex-shrink-0">{icon}</div>}

        {/* Content */}
        <div className="pr-8">
          {content.type === 'text' ? <span>{content.message}</span> : content.content}
        </div>
      </div>
    </div>
  );
};

export default ToastMessage;
